import { fromBech32 } from '@cosmjs/encoding/build/bech32';
import { getAddress as decodeEth } from 'ethers';
import bs58 from 'bs58';

export const decodeFromBech32 = (key) => {
    try {
        fromBech32(key);
        return true;
    } catch (e) {
        return false;
    }
};

export const checkEth = (key) => {
    try {
        decodeEth(key);
        return true;
    } catch {
        return false;
    }
};

export const checkSolana = (key) => {
    try {
        const decoded = bs58.decode(key);
        if (decoded.length === 32) {
            return true;
        }
    } catch (error) {
        return false;
    }
};
